(function () {
  'use strict';

  if (window.__BETTUP_STORE_IMPROVEMENTS__) return;
  window.__BETTUP_STORE_IMPROVEMENTS__ = true;

  var config = window.BETTUP_STORE_IMPROVEMENTS || {};
  var freeShippingLabel = 'Versandkostenfrei ab 50 € Bestellwert';
  var whatsappUrl = 'https://wa.me/4915251741750?text=' + encodeURIComponent('Hallo bettUP, ich möchte prüfen lassen, ob ein Ersatzkern in mein Boxspringbett passt.');

  function replaceText(root, replacements) {
    if (!root || !document.createTreeWalker) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentElement;
        if (!parent || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/i.test(parent.tagName)) {
          return NodeFilter.FILTER_REJECT;
        }
        return node.nodeValue && node.nodeValue.trim()
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      }
    });

    var nodes = [];
    var current;
    while ((current = walker.nextNode())) nodes.push(current);

    nodes.forEach(function (node) {
      var value = node.nodeValue;
      replacements.forEach(function (replacement) {
        value = value.split(replacement.from).join(replacement.to);
      });
      node.nodeValue = value;
    });
  }

  function improveShippingPolicy(root) {
    var scope = root || document;

    scope.querySelectorAll('.shipping-policy').forEach(function (node) {
      var existingLink = node.querySelector('a');
      var href = existingLink && existingLink.href
        ? existingLink.href
        : '/policies/shipping-policy';

      node.textContent = '';
      var check = document.createElement('span');
      check.className = 'bettup-shipping-check';
      check.setAttribute('aria-hidden', 'true');
      check.textContent = '✓';

      var link = document.createElement('a');
      link.href = href;
      link.textContent = freeShippingLabel;

      node.appendChild(check);
      node.appendChild(document.createTextNode(' '));
      node.appendChild(link);
      node.dataset.bettupShippingUpdated = 'true';
    });

    scope.querySelectorAll('.template-product a[href*="policies/shipping"], .template-product .product-price a').forEach(function (link) {
      if (link.closest('[data-bettup-static-shipping]')) return;
      var parent = link.parentElement;
      if (!parent) return;
      var text = String(parent.textContent || '').replace(/\s+/g, ' ').trim();
      if (/versand.*bezahlvorgang|bezahlvorgang.*versand|kostenloser versand/i.test(text)) {
        parent.textContent = freeShippingLabel + ' innerhalb Deutschlands.';
      }
    });
  }

  function correctHomepageCopy(root) {
    if (config.pageType !== 'index') return;

    replaceText(root || document.getElementById('MainContent') || document.body, [
      {
        from: 'Wichtig ist vor allem die Höhe – unsere Kerne passen ideal bei 18–23 cm.',
        to: 'Wichtig ist vor allem die Höhe: Federkerne gibt es in 18–23 cm, den Naturlatex-Kern in 18 cm.'
      },
      {
        from: 'Ja, wenn die Maße stimmen. Entscheidend ist die Kernhöhe von 18–23 cm. Bei Unsicherheit schick uns einfach die Maße oder ein Foto – wir sagen dir, ob es passt.',
        to: 'Ja, wenn die Maße stimmen. Unsere Federkerne gibt es in 18–23 cm, den Naturlatex-Kern in 18 cm. Bei Unsicherheit schick uns einfach die Maße oder ein Foto – wir sagen dir, ob es passt.'
      },
      {
        from: 'Kerne und Topper liefern wir per Paketdienst bis zur Haustür, in der Regel in 7–10 Werktagen.',
        to: 'Kerne und Topper liefern wir ab 50 € Bestellwert versandkostenfrei bis zur Haustür, in der Regel in 7–10 Werktagen.'
      }
    ]);
  }

  function correctNaturlatexDescription(root) {
    if (config.productHandle !== 'bettup-ersatzmatratze-boxspringbett-naturlatex') return;

    var scope = root || document;
    var descriptions = scope.querySelectorAll('.type_description .product-description, .type_description .rte.description');

    descriptions.forEach(function (description) {
      replaceText(description, [
        {
          from: 'Als Faustregel nach Körpergewicht: H2 für 60–79 kg, H3 für 80–99 kg, H4 für 100–120 kg. Wenn du Seitenschläfer bist oder breitere Schultern und Hüften hast, wähl am besten eine Stufe weicher – so kann die Schulter gut einsinken und die Wirbelsäule bleibt gerade.',
          to: 'Wähle zwischen Mittel und Fest. Mittel passt, wenn du weicher und anschmiegsamer liegen möchtest. Fest bietet mehr Stabilität. Bei Unsicherheit helfen wir dir persönlich bei der Auswahl.'
        },
        {
          from: 'Der Naturlatex-Kern passt ideal bei einer Kernhöhe von 18–23 cm und ist in allen gängigen Größen von 80×200 cm bis 200×200 cm erhältlich.',
          to: 'Der Naturlatex-Kern ist 18 cm hoch und in allen gängigen Größen von 80×200 cm bis 200×200 cm erhältlich.'
        },
        {
          from: 'Härtegrad: H2 (60–79 kg), H3 (80–99 kg), H4 (100–120 kg) – Seitenschläfer eine Stufe weicher',
          to: 'Festigkeit: Mittel oder Fest'
        },
        {
          from: 'Kernhöhe: 18–23 cm (bitte passend zu deinem Bett wählen)',
          to: 'Kernhöhe: 18 cm'
        }
      ]);
    });
  }

  function upgradeMeasureCheck(root) {
    var scope = root || document;
    var existingButton = scope.querySelector('.bettup-measure-check__primary');

    if (existingButton) {
      existingButton.href = whatsappUrl;
      existingButton.target = '_blank';
      existingButton.rel = 'noopener';
      existingButton.textContent = 'Maße kostenlos per WhatsApp prüfen lassen';
      existingButton.removeAttribute('data-bettup-measure-email');
      existingButton.setAttribute('data-bettup-measure-whatsapp', 'true');
    }

    if (config.pageType !== 'product' || config.productType !== 'Matratzenkern') return;

    var shippingPolicy = scope.querySelector('.shipping-policy');
    var buttons = scope.querySelector('.product-form .buttons, form[action*="/cart/add"] .buttons, .add-to-cart');
    var anchor = shippingPolicy || buttons;
    if (!anchor) return;

    if (config.productHandle === 'bettup-ersatzmatratze-boxspringbett-naturlatex' && !document.querySelector('.bettup-product-facts')) {
      var facts = document.createElement('p');
      facts.className = 'bettup-product-facts';
      facts.innerHTML = '<strong>Naturlatex klar gewählt:</strong> 18 cm Kernhöhe, Festigkeit Mittel oder Fest.';

      if (shippingPolicy) {
        shippingPolicy.insertAdjacentElement('afterend', facts);
      } else if (buttons.classList.contains('add-to-cart')) {
        buttons.insertAdjacentElement('beforebegin', facts);
      } else {
        buttons.insertAdjacentElement('beforebegin', facts);
      }
    }

    if (!existingButton && !document.querySelector('.bettup-measure-check-compact')) {
      var compact = document.createElement('a');
      compact.className = 'bettup-measure-check-compact';
      compact.href = whatsappUrl;
      compact.target = '_blank';
      compact.rel = 'noopener';
      compact.textContent = 'Maße kostenlos per WhatsApp prüfen lassen';

      if (shippingPolicy) {
        shippingPolicy.insertAdjacentElement('afterend', compact);
      } else if (buttons.classList.contains('add-to-cart')) {
        buttons.insertAdjacentElement('beforebegin', compact);
      } else {
        buttons.insertAdjacentElement('beforebegin', compact);
      }
    }
  }

  function initialize(scope) {
    improveShippingPolicy(scope || document);
    correctHomepageCopy(scope || document);
    correctNaturlatexDescription(scope || document);
    upgradeMeasureCheck(scope || document);
  }

  function run() {
    initialize(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  [400, 1000, 2200, 4200, 7600].forEach(function (delay) {
    window.setTimeout(run, delay);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target || document);
  });
})();